var _linearGradient, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCartfill(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "customGradient",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#458FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#CF6AFF"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2596 20.3107C10.2596 21.1519 9.5777 21.8338 8.73653 21.8338C7.89536 21.8338 7.21345 21.1519 7.21345 20.3107C7.21345 19.4695 7.89536 18.7876 8.73653 18.7876C9.5777 18.7876 10.2596 19.4695 10.2596 20.3107Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8596 21.8338C17.7008 21.8338 18.3827 21.1519 18.3827 20.3107C18.3827 19.4695 17.7008 18.7876 16.8596 18.7876C16.0184 18.7876 15.3365 19.4695 15.3365 20.3107C15.3365 21.1519 16.0184 21.8338 16.8596 21.8338Z",
    fill: "current"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.83066 3.15076C1.32595 3.15076 0.916809 3.55986 0.916809 4.06457C0.916809 4.56927 1.32595 4.97841 1.83066 4.97841H4.53709C4.58616 4.97841 4.62821 5.01136 4.63699 5.05964L6.36457 15.0712C6.53136 15.9885 7.33032 16.6553 8.26269 16.6553H18.5845C19.0892 16.6553 19.4983 16.2462 19.4983 15.7415C19.4983 15.2368 19.0892 14.8276 18.5845 14.8276H8.26269C8.21362 14.8276 8.17156 14.7925 8.16279 14.7443L8.04871 13.6092H18.7288C19.681 13.6092 20.4908 12.9156 20.6356 11.9744L21.3385 7.40518C21.5183 6.23653 20.6141 5.18149 19.4317 5.18149H6.51641L6.4352 4.22706C6.26841 3.30973 5.46946 3.15076 4.53709 3.15076H1.83066Z",
    fill: "current"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCartfill);
export default __webpack_public_path__ + "static/media/cart.fill.a9937d757a6f45f3475ae525b06ef346.svg";
export { ForwardRef as ReactComponent };